module.exports = __webpack_public_path__ + "static/efe-kurnaz-RnCPiXixooY-unsplash-379f756f99c77391b40b8e80efbfd737.jpg";